import { render } from "./ArrowDownIcon.vue?vue&type=template&id=10bbdf2a"
import script from "./ArrowDownIcon.vue?vue&type=script&lang=js"
export * from "./ArrowDownIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__